
   import { defineComponent } from "vue";

   import { Login } from "@/ApiInterfaces";
   import ModalLoading from "@/components/ModalLoading.vue";
   import ModalErrorMessage from "@/components/ModalErrorMessage.vue";
   import { parseApiError, fieldError, getFieldErrorMsg, hasFieldError } from "@/apiErrorHandling";
   import { saveAuthToken } from "@/security";

   interface LoginData {
      email: string;
      password: string;
      remember: boolean;
      loading: boolean;
      errorMessage: null | string;
      fieldErrors: null | fieldError[];
   }

   export default defineComponent({
      name: 'Login',
      data(): LoginData {
         return {
            email: "",
            password: "",
            remember: true,
            loading: false,
            errorMessage: null,
            fieldErrors: null
         }
      },
      components: {
         ModalLoading,
         ModalErrorMessage
      },
      mounted() {
         document.getElementById('email')?.focus();
      },
      methods: {
         submitLogin(): void {
            try {
               this.loading = true;

               const login: Login = {
                  email: this.email,
                  password: this.password,
                  sessionOnly: !this.remember
               }

               fetch(
                  `/api/contacttokens/authenticate`,
                  {
                     method: "post",
                     headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                     },
                     body: JSON.stringify(login),
                  }
               )
                  .then((r) => {
                     this.loading = false;
                     if (r.ok) {
                        r.text().then((t) => {
                           // Save login token
                           saveAuthToken(JSON.parse(t));

                           var params = new URLSearchParams(window.location.search);
                           if (params.has("r") && params.get("r"))
                              window.location.href = params.get("r")!;
                           else
                              window.location.href = "/cms/dashboard";
                        })
                     } else if (r.status == 401) {
                        this.errorMessage = "Email address or password is incorrect.";
                     } else {
                        r.text().then((t) => {
                           const errs = parseApiError(t);
                           // Setting these will automatically update the disply and show an error
                           this.fieldErrors = errs.fieldErrors;
                           this.errorMessage = errs.message;
                        });
                     }
                  })
                  .catch((e) => {
                     this.loading = false;
                     this.errorMessage = "Something went wrong. Please try again later.";
                     console.error(e.toString());
                  });
            } catch (e) {
               this.loading = false;
               this.errorMessage = "Something went wrong. Please try again later.";
               console.error(e.toString());
            }
          }

          
         //dtExternalLogin(): void {
         //    try {
         //        this.loading = true;

         //        const login: Login = {
         //            email: this.email,
         //            password: this.password,
         //            sessionOnly: !this.remember
         //        }

         //        fetch(
         //            `/api/DTExternal/login`,
         //            {
         //                method: "get",
         //                headers: {
         //                    Accept: "application/json",
         //                    "Content-Type": "application/json",
         //                },
         //                body: JSON.stringify(login),
         //            }
         //        )
         //            .then((r) => {
         //                this.loading = false;
         //                if (r.ok) {
         //                    r.text().then((t) => {
         //                    //    // Save login token
         //                    //    saveAuthToken(JSON.parse(t));

         //                    //    var params = new URLSearchParams(window.location.search);
         //                    //    if (params.has("r") && params.get("r"))
         //                    //        window.location.href = params.get("r")!;
         //                    //    else
         //                    //        window.location.href = "/cms/dashboard";
         //                        this.errorMessage = JSON.parse(t)
         //                    })
                             
         //                } else if (r.status == 401) {
         //                    this.errorMessage = "Email address or password is incorrect.";
         //                } else {
         //                    r.text().then((t) => {
         //                        const errs = parseApiError(t);
         //                        // Setting these will automatically update the disply and show an error
         //                        this.fieldErrors = errs.fieldErrors;
         //                        this.errorMessage = errs.message;
         //                    });
         //                }
         //            })
         //            .catch((e) => {
         //                this.loading = false;
         //                this.errorMessage = "Something went wrong. Please try again later.";
         //                console.error(e.toString());
         //            });
         //    } catch(e) {
         //     this.loading = false;
         //     this.errorMessage = "Something went wrong. Please try again later.";
         //     console.error(e.toString());
         // }
         //}
      }
   });

